import React from 'react';
import NumberFormat from 'react-number-format';
import styled from 'styled-components/macro';
import useTranslations from '../../../hooks/useTranslations';
import Colors from '../../../internal-components/Colors';

const ScoreContainer = styled.div`
  background-color: ${Colors.BACKGROUND_GREY};
  border-radius: 4px;
  font-size: 24px;
  padding: 0.5rem 1rem;
  width: fit-content;
  .error {
    font-size: 16px;
    font-style: italic;
  }
`;

const ScoreFieldView = props => {
  const t = useTranslations();
  const errorMode = props.value === null && !props.isFormPreview;
  return (
    <ScoreContainer data-calc-id={props.internalId}>
      {props.value || props.value === 0 ? (
        <NumberFormat
          displayType="text"
          value={props.value}
          thousandSeparator
          className={errorMode ? 'error' : ''}
        />
      ) : props.isFormPreview ? (
        <>&nbsp;</>
      ) : (
        <span className={errorMode ? 'error' : ''}>
          {t('forms.fields.score_error')}
        </span>
      )}
    </ScoreContainer>
  );
};

export default ScoreFieldView;
